import React, { useState, useEffect, useRef } from "react";
import { captureSubmissionError } from "../../utils/sentryUtils";
import SubmittingCard from "../../components/SubmittingCard";
import SubmissionErrorCard from "../../components/SubmissionErrorCard";
import { TA10Config } from "./TA10Config";

const TA10Submission = ({ TA10FlowState: flowState, rooms, onFlowComplete }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ref guard prevents StrictMode double-mount from firing a second request
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    const submission = {
      rooms,
      section1: flowState.section1,
      section2: flowState.section2,
      section3: flowState.section3,
      section4: {
        title: TA10Config[4].sectionTitle,
        items: [],
      },
      section5: {
        title: TA10Config[5].sectionTitle,
        items: [],
      },
      section6: {
        title: TA10Config[6].sectionTitle,
        items: [],
      },
      section7: {
        title: TA10Config[7].sectionTitle,
        items: [],
      },
      section8: {
        title: TA10Config[8].sectionTitle,
        items: [],
      },
      section9: flowState.section9,
      section10: flowState.section10,
      section11: flowState.section11,
      section12: flowState.section12,
      sectionRooms: flowState.sectionRooms,
    };

    fetch("/api/propertyInformationFormTA10", {
      method: "PUT",
      body: JSON.stringify({
        formRequestId: flowState.formRequestId,
        ta10Data: submission,
      }),
    })
      .then(
        async (resp) => {
          if (resp.ok) {
            setLoading(false);
            onFlowComplete();
          } else {
            const body = await resp.text().catch(() => "");
            console.error("TA10 submission failed:", resp.status, body);
            captureSubmissionError("TA10", resp.status, body);
            setError("Unable to process your details");
            setLoading(false);
          }
        },
        (err) => {
          console.error("TA10 submission failed:", err);
          setError("Unable to process your details");
          setLoading(false);
        },
      )
      .catch((err) => {
        console.error("TA10 submission failed:", err);
        setError("Unable to process your details");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- submit once on mount; ref guard prevents StrictMode re-fire

  if (loading) {
    return <SubmittingCard />;
  }

  if (error) {
    return <SubmissionErrorCard error={error} />;
  }

  return null;
};

export default TA10Submission;
